import type { CSSProperties } from "react"

import { RankChangeType } from "@/widgets/search-ranking/model/types"

interface RankChangeProps {
  type: RankChangeType
  value?: number
}

const bebasStyle = { fontFamily: "var(--font-bebas-neue), sans-serif" } as CSSProperties
const rankChangeTextStyle = { ...bebasStyle, "--fs": 14, "--lh": 14 } as CSSProperties
const rankChangeArrowStyle = { ...bebasStyle, "--fs": 10, "--lh": 10 } as CSSProperties

const RankChange = ({ type, value }: RankChangeProps) => {
  if (type === "new") {
    return (
      <span className="fs font-normal uppercase tracking-[0.21px] text-[#E85A5D]" style={rankChangeTextStyle}>
        new
      </span>
    )
  }

  if (type === "same") {
    return (
      <span className="fs font-bold text-gray-200" style={rankChangeTextStyle}>
        -
      </span>
    )
  }

  if (type === "down") {
    return (
      <span className="inline-flex items-center gap-0.5 text-[#7FCCF0]" style={bebasStyle}>
        <span className="fs leading-none" style={rankChangeArrowStyle}>
          ▼
        </span>
        <span className="fs" style={rankChangeTextStyle}>
          {value}
        </span>
      </span>
    )
  }

  return (
    <span className="inline-flex items-center gap-0.5 text-[#E85A5D]" style={bebasStyle}>
      <span className="fs leading-none" style={rankChangeArrowStyle}>
        ▲
      </span>
      <span className="fs" style={rankChangeTextStyle}>
        {value}
      </span>
    </span>
  )
}

export default RankChange
